import { FC } from 'react';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { useAppSelector } from 'redux/hooks';
import { makeStaticUrl } from '@doda/common/src/logics/staticUrl';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { createPreBtn } from '@doda/common/src/logics/JobContent/createPreBtn';
import { convertQueryToURI } from '@doda/common/src/logics/JobContent/convertQueryToURI';
import { createOccupationUrl } from '@doda/common/src/logics/JobContent/createOccupationUrl';
import styles from './index.module.scss';

export const HeaderTab: FC = () => {
  // queryの取得
  const queryParams = useAppSelector(appQueryParamsSelector);

  const jobSearchListUrl = makeStaticUrl(
    createPreBtn(convertQueryToURI(queryParams)),
    DODA_SITE_URL.jobSearchList
  );

  // 市区町村パラメータの場合、求人ランキングリンク生成しない
  const jobRankingUrl = queryParams.ci
    ? ''
    : makeStaticUrl(convertQueryToURI(queryParams), DODA_SITE_URL.jobRanking);

  const occupationUrl = createOccupationUrl(queryParams);

  return (
    <div className={styles.headerTab}>
      <ul className={styles.headerTab__list}>
        <li className={styles.headerTab__item}>
          <a className="headerTab__item--link" href={jobSearchListUrl}>
            求人一覧
          </a>
        </li>
        <li className={styles.headerTab__item}>
          <span className="headerTab__item--title">求人の傾向</span>
        </li>
        {jobRankingUrl && (
          <li className={styles.headerTab__item}>
            <a className="headerTab__item--link" href={jobRankingUrl}>
              人気求人ランキング
            </a>
          </li>
        )}
        {occupationUrl && (
          <li className={styles.headerTab__item}>
            <a className="headerTab__item--link" href={occupationUrl}>
              職業別の求人数
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};
